import { render, staticRenderFns } from "./TextGenerator.vue?vue&type=template&id=27739a81&scoped=true"
import script from "./TextGenerator.vue?vue&type=script&lang=js"
export * from "./TextGenerator.vue?vue&type=script&lang=js"
import style0 from "./TextGenerator.vue?vue&type=style&index=0&id=27739a81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27739a81",
  null
  
)

export default component.exports